import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4810bdcd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error__modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error__image" }, null, -1))
const _hoisted_3 = { class: "error__title" }
const _hoisted_4 = { class: "error__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "error__wrapper",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeErrorModal && $setup.closeErrorModal(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("h3", _hoisted_3, _toDisplayString($setup.title), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString($setup.text), 1),
      _createElementVNode("button", {
        class: "button button--black",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _toDisplayString($setup.buttonLabel), 1)
    ])
  ]))
}